// extracted by mini-css-extract-plugin
module.exports = {"traceCodeButtonUploaded":"DeliveryList_traceCodeButtonUploaded__1HsF9"};